module.exports = __webpack_public_path__ + "media/3-17a.bbc1c37e.mp4";